import React from "react";

import { Menu } from "@headlessui/react";

import DropdownButtonItem from "./DropdownItem/DropdownButtonItem";
import DropdownItems from "./DropdownItems/DropdownItems";
import DropdownLinkItem from "./DropdownItem/DropdownLinkItem";
import DropdownTrigger from "./DropdownTrigger/DropdownTrigger";
import DropdownSeparator from "./DropdownSeparator/DropdownSeparator";

interface Props {
    children: ((Props: { open: boolean }) => React.ReactElement) | React.ReactNode
}

const Dropdown = ({ children }: Props) => {

    // TODO: button loading states

    return (
        <Menu as="div" className="relative">
            {(typeof children === 'function') ? (props) => (children(props)) : children}
        </Menu>
    );
};

Dropdown.Trigger = DropdownTrigger;
Dropdown.Separator = DropdownSeparator;
Dropdown.Items = DropdownItems;
Dropdown.ButtonItem = DropdownButtonItem;
Dropdown.LinkItem = DropdownLinkItem;

export default Dropdown;



